<ion-toggle
  #toggle
  [formControl]="control"
  [class.error]="control?.errors && control?.touched"
  labelPlacement="end"
  justify="start"
  color="primary"
  data-test-id="toggle-component.wrapper">
  {{ label | transloco }}
</ion-toggle>

@if (control?.errors && control?.touched) {
  <div class="error-wrapper">
    <c-validation-error [validationMessages]="control?.errors" [controlValue]="control?.value"> </c-validation-error>
  </div>
}
